import React, { Component } from 'react';
import $ from 'jquery';
import Loading from '../assets/loading.gif';
import classie from './js/classie.js';
import './css/Style.css';
import './css/normalize.css';
import './css/demo.css';
import './css/component.css';
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.css';


class Index extends Component {
  componentDidMount() {
    let { geocode, tipo } = this.props.match.params;

    var isMenuOpen = false; 
    var api_Estatico = 'https://apimeteograma.inmet.gov.br'; 
    var api_Dinamico = 'https://apiprevmet3.inmet.gov.br'; 
    
    const produtos = [
      {'sigla' : 'dinamico', 'nome' : 'Dinâmico'},
      {'sigla' : 'estatico', 'nome' : 'Pré Determinado'},
      {'sigla' : 'agricultor', 'nome' : 'Por Coordenada'},
    ];
    
    const tipos_dinamico = [
      {'sigla' : 1, 'nome' : 'Fixo'},
      // {'sigla' : 2, 'nome' : 'Espacial'},
    ];
    
    const rodadas_dinamico = [
      {'sigla' : '00' , 'nome' : '00'},
      {'sigla' : '12' , 'nome' : '12'},
    ];
    
    var cidade_dinamica = {
      "id": "Brasília-DF",
      "label": "Brasília/DF",
      "value": "Brasília/DF",
      "custom": "DF/Brasília",
      "geocode": "5300108",
      "lat": "-15.78",
      "lon": "-47.93"
    };
    
    function geraOptions(element, data, selecione = true, atributo_inicial = '') {
      var opt = document.createElement('option');
      if(selecione) {
        opt.innerHTML = 'Selecione';
        element.append(opt);
      }
      
      for (var i = 0; i < data.length; i++) {
        opt = document.createElement('option');
        opt.value = data[i].sigla;
        opt.innerHTML = data[i].nome;

        if(data[i].sigla === atributo_inicial)
          opt.setAttribute('selected', 'selected');
        element.append(opt);
      }
    }
    
    function removeOption(element) {
      var elements = element.find('option');
      for (var i = 0; i < elements.length; i++)
      elements[i].remove();
    }
    
    function getDatas () {
        let datas = []
        
        let date = new Date();
        
        let start = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - 10, date.getUTCHours() - 3, date.getUTCMinutes(), date.getUTCSeconds())).toISOString().split('T')[0]
        let end = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours() - 3, date.getUTCMinutes(), date.getUTCSeconds())).toISOString().split('T')[0]
        
        let dtStart = new Date(start)
        let dtEnd = new Date(end)
        
        while (dtStart <= dtEnd) {
            datas.push({ 
              'sigla' : dtStart.toISOString().split('T')[0],
              'nome' : dtStart.toISOString().split('T')[0].split('-').reverse().join('/')
            })
            dtStart.setDate(dtStart.getDate() + 1);
        }
      return datas.reverse();
    }

    async function dadosBrasilia(){
      let hora, hoje;
      await $.get(`${api_Dinamico}/previsao/5300108`, function(response) {
        hora = response['5300108'][Object.keys(response['5300108'])[0]]['manha']['hora'];
        hoje = `${Object.keys(response['5300108'])[0].split('/').reverse().join('-')}T${hora}:00:00`;
      });
      return [hoje, hora];
    }

    function abrirMenu(bool){
      if(bool){
        classie.add( document.getElementById('menu'), 'gn-selected' );
        classie.add( document.getElementById('wrapper'), 'gn-open-all' );
        isMenuOpen = true;
      }else{
        classie.remove( document.getElementById('menu'), 'gn-selected' );
        classie.remove( document.getElementById('wrapper'), 'gn-open-all' );
        isMenuOpen = false;
      }
    }
    
    async function montarMenuMeteogramaDinamico(){
      let brasilia = await dadosBrasilia();

      removeOption($('#menu_Dinamico .tipo'));
      removeOption($('#menu_Dinamico .data'));
      removeOption($('#menu_Dinamico .rodada'));

      geraOptions($('#menu_Dinamico .tipo'), tipos_dinamico, false);
      geraOptions($('#menu_Dinamico .data'), getDatas(), false);
      geraOptions($('#menu_Dinamico .rodada'), rodadas_dinamico, false, brasilia[1] < 14 ? '00' : '12');

      $('#menu_Dinamico #search').val(cidade_dinamica.label);
    }

    async function montarMenuAgricultor(){
      removeOption($('#menu_Agricultor .tipo'));
      removeOption($('#menu_Agricultor .data'));
      removeOption($('#menu_Agricultor .rodada'));

      geraOptions($('#menu_Agricultor .tipo'), tipos_dinamico, false);
      geraOptions($('#menu_Agricultor .data'), getDatas(), false);
      geraOptions($('#menu_Agricultor .rodada'), rodadas_dinamico, false);

      $('#menu_Agricultor #latitude').val(cidade_dinamica.lat);
      $('#menu_Agricultor #longitude').val(cidade_dinamica.lon);
    }
    
    function dynamicMenus(tipo){
      $('#menu_Dinamico').css('display', 'none');
      $('#menu_Estatico').css('display', 'none');
      $('#menu_Agricultor').css('display', 'none');
      
      if(tipo === 'estatico'){
        $('#menu_Estatico').css('display', 'inline');
      }else if(tipo === 'dinamico'){
        $('#menu_Dinamico').css('display', 'inline');
        montarMenuMeteogramaDinamico();
      }else if(tipo === 'agricultor'){
        montarMenuAgricultor();
        $('#menu_Agricultor').css('display', 'inline');
      }
    }

    async function init() {
      await $.get(`${api_Dinamico}/buscar/cidade/${geocode}`, function(response) {
        if(response.length > 0){
          cidade_dinamica = {
            "id": response[0].id,
            "label": response[0].label,
            "value": response[0].value,
            "custom": response[0].custom,
            "geocode": response[0].geocode,
            "lat": response[0].lat,
            "lon": response[0].lon
          };
        }
      });

      if(tipo === 'dinamico'){
        let brasilia = await dadosBrasilia();

        geraOptions($('.produto'), produtos, true, 'dinamico');
        dynamicMenus('dinamico');
        $('#menu_Dinamico .rodada').val(brasilia[1] < 14 ? '00' : '12');
        $('#submit_Dinamico').click();
      }else if(tipo === 'agricultor'){
        geraOptions($('.produto'), produtos, true, 'agricultor');
        dynamicMenus('agricultor');
      }else{
        dynamicMenus('nenhum');
        geraOptions($('.produto'), produtos);
      }
      abrirMenu(true);
    }

    async function detectMobile() {
      if(navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)) {
        abrirMenu(false)
      }
    }

    $(document).ready(async function() {
      if(geocode){
        await init();
      }else{
        geocode = '5300108'
        tipo = 'dinamico'
        await init();
      }

      await detectMobile()

      $('.produto').change(function() {
        removeOption($('#menu_Estatico .modelo'));
        removeOption($('#menu_Estatico .pais'));
        removeOption($('#menu_Estatico .estado'));
        removeOption($('#menu_Estatico .cidade'));
        removeOption($('#menu_Estatico .data'));
        removeOption($('#menu_Estatico .rodada'));
        
        removeOption($('#menu_Dinamico .tipo'));
        removeOption($('#menu_Dinamico .cidade'));
        removeOption($('#menu_Dinamico .data'));
        removeOption($('#menu_Dinamico .rodada'));
        
        var produto = $('.produto').val();
        dynamicMenus(produto);
        
        if(produto === 'estatico'){
          $.get(`${api_Estatico}/modelos`, function(response) {
            geraOptions($('.modelo'), response);
          });
        }
      });
      
      $('#menu_Estatico .modelo').change(function() {
        var modelo = $('#menu_Estatico .modelo').val();
        
        $.get(`${api_Estatico}/pais/${modelo}`, function(response) {
          removeOption($('#menu_Estatico .pais'));
          removeOption($('#menu_Estatico .estado'));
          removeOption($('#menu_Estatico .cidade'));
          removeOption($('#menu_Estatico .data'));
          removeOption($('#menu_Estatico .rodada'));
          geraOptions($('#menu_Estatico .pais'), response);
        });
      });
      
      $('#menu_Estatico .pais').change(function() {
        var modelo = $('#menu_Estatico .modelo').val();
        var pais  = $('#menu_Estatico .pais').val();
        
        $.get(`${api_Estatico}/estado/${modelo}/${pais}`, function(response) {
          removeOption($('#menu_Estatico .estado'));
          removeOption($('#menu_Estatico .cidade'));
          removeOption($('#menu_Estatico .data'));
          removeOption($('#menu_Estatico .rodada'));
          geraOptions($('#menu_Estatico .estado'), response);
        });
      });
      
      $('#menu_Estatico .estado').change(function() {
        var modelo = $('#menu_Estatico .modelo').val();
        var pais  = $('#menu_Estatico .pais').val();
        var estado = $('#menu_Estatico .estado').val();
        
        $.get(`${api_Estatico}/cidade/${modelo}/${pais}/${estado}`, function(response) {
          removeOption($('#menu_Estatico .cidade'));
          removeOption($('#menu_Estatico .data'));
          removeOption($('#menu_Estatico .rodada'));
          geraOptions($('#menu_Estatico .cidade'), response);
        });
      });
      
      $('#menu_Estatico .cidade').change(function() {
        var modelo = $('#menu_Estatico .modelo').val();
        var pais  = $('#menu_Estatico .pais').val();
        var estado = $('#menu_Estatico .estado').val();
        var cidade = $('#menu_Estatico .cidade').val();
        
        $.get(`${api_Estatico}/data/${modelo}/${pais}/${estado}/${cidade}`, function(response) {
          removeOption($('#menu_Estatico .data'));
          removeOption($('#menu_Estatico .rodada'));
          geraOptions($('#menu_Estatico .data'), response);
        });
      });
      
      $('#menu_Estatico .data').change(function() {
        var modelo = $('#menu_Estatico .modelo').val();
        var pais  = $('#menu_Estatico .pais').val();
        var estado = $('#menu_Estatico .estado').val();
        var cidade = $('#menu_Estatico .cidade').val();
        var data = $('#menu_Estatico .data').val();
        
        $.get(`${api_Estatico}/rodada/${modelo}/${pais}/${estado}/${cidade}/${data}`, function(response) {
          removeOption($('#menu_Estatico .rodada'));
          geraOptions($('#menu_Estatico .rodada'), response);
        });
      });

      $('#menu_Estatico .rodada').change(function() {
        $('#submit_Estatico').click()
      });

      $('#menu_Dinamico .data').change(function() {
        $('#submit_Dinamico').click()
      });

      $('#menu_Dinamico .rodada').change(function() {
        $('#submit_Dinamico').click()
      });

      $('#menu_Agricultor .data').change(function() {
        $('#submit_Agricultor').click()
      });

      $('#menu_Agricultor .rodada').change(function() {
        $('#submit_Agricultor').click()
      });
    });
    
    $(function () {
      $('#search').autocomplete({
        minLength: 2,
        maxResults: 20,
        source: function (request, response){
          $.ajax({
            url: `https://apiprevmet3.inmet.gov.br/autocomplete/${request.term.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`,
            dataType: "json",
            success: response,
            error: function () {
              response([]);
            }
          });
        },
        select: function( event, ui ) {
          event.preventDefault();
          $('label[for="local"] strong').html(decodeURIComponent(ui.item.value.replace(/\+/g, ' ')));
          $('#search').val('Aguarde...');
          cidade_dinamica = ui.item;
          $('#search').val(cidade_dinamica.label);
          $('#submit_Dinamico').click()
        }
      }).autocomplete('instance')._renderItem = function( ul, item ) {
        return $('<li>')
        .append('<div>' + decodeURIComponent(item.label.replace(/\+/g, ' ')) + '</div>')
        .appendTo(ul);
      };
    });
    
    $('.input').keypress(function (e) {
      return false;
    });

    // Ativa o FullScreen
    $('.ativar-fullScreen').click(function(e) {
      $('previsaoList').css('display', 'none');
      $('.previsaoList').css('display', 'none');
      $('.municipio').css('display', 'none');
      $('.img').css('max-height', '95%');
      $('.img').css('height', '95%');

      // Esconde o topo do site, deixando só a imagem e os controladores
      var element = $("#containerFullScreen")[0];
      var tmp = element.mozRequestFullScreen || element.webkitRequestFullscreen || element.requestFullscreen;
      tmp.call(element); 
    });
    
    $('#containerFullScreen').bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
      var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      var event = state ? 'FullscreenOn' : 'FullscreenOff';
      
      if(event === 'FullscreenOff'){
        $('.ativar-fullScreen').css('display', 'inline');
        $('.img').css('max-height', '85%');
        $('.img').css('height', '85%');
        $('.municipio').css('display', 'block');
        $('.previsaoList').css('display', 'inline');
      }
    });

    $('.submit').click(async function(e) {
      $('.municipio').empty()
      var produto = $('.produto').val();
      
      if(produto === 'estatico'){
        
        var modelo = $('#menu_Estatico .modelo').val();
        var pais  = $('#menu_Estatico .pais').val();
        var estado = $('#menu_Estatico .estado').val();
        var cidade = $('#menu_Estatico .cidade').val();
        var data = $('#menu_Estatico .data').val();
        var rodada = $('#menu_Estatico .rodada').val();
        
        
        if(modelo && modelo !== 'Selecione' && pais && pais !== 'Selecione' && estado && estado !== 'Selecione' && cidade && cidade !== 'Selecione'  && data && data !== 'Selecione'  && rodada && rodada !== 'Selecione'){
          $('.img').css('display', 'inline'); 
          $('.img').attr('src', Loading);
          
          $('.previsaoList').css('display', 'none'); // Esconde a div que mostra o erro e o icone full screen
          $('.previsaoList').find('font').remove(); // Remove o span de erro
          
          $.get(`${api_Estatico}/${modelo}/${pais}/${estado}/${cidade}/${data}/${rodada}`, function(response) {
            $('.img').attr('src', response[0].base64);
            // $('.imgHref').attr('href', response[0].base64);
            $('.previsaoList').css('display', 'inline');
            $('.ativar-fullScreen').css('display', 'inline');
          });
        }
      }else if(produto === 'dinamico'){
        $('.img').css('display', 'inline'); 
        $('.img').attr('src', Loading);
        
        $('.previsaoList').css('display', 'none'); // Esconde a div que mostra o erro e o icone full screen
        $('.previsaoList').find('font').remove(); // Remove o span de erro
        
        var tipo = $('#menu_Dinamico .tipo').val();
        // eslint-disable-next-line
        var data = $('#menu_Dinamico .data').val();
        // eslint-disable-next-line
        var rodada = $('#menu_Dinamico .rodada').val();
        
        var url = `${api_Dinamico}/meteograma`;
        // eslint-disable-next-line
        if(tipo == 2)
          url = `${api_Dinamico}/meteograma/espacial`;
        else
          url = `${api_Dinamico}/meteograma`;

        let brasilia = await dadosBrasilia();

        if(!rodada)
          brasilia[1] < 14 ? rodada = '00' : rodada = '12';

        if(!data)
          data = brasilia[0].split('T')[0];
        
        $.get(`${url}/${cidade_dinamica.geocode}/${data}/${rodada}`, function(response) {
          if(response.base64.includes('data:text/xml;')){
            $('.img').css('display', 'none');
            $('.previsaoList').css('display', 'inline');
            $('.ativar-fullScreen').css('display', 'none');
            $('.previsaoList').append('<font color="RED" size="10">A imagem não existe, tente com outros parâmetros!</font>');
          }else{
            $('.img').attr('src', response.base64);
            $('.municipio').text(cidade_dinamica.label)
            $('.previsaoList').css('display', 'inline');
            $('.ativar-fullScreen').css('display', 'inline');
          }
        }).fail(function(){
          // Esconde a imagem de load
          $('.img').css('display', 'none');
          // Mostra a div que irá mostrar a mensagem de erro
          $('.previsaoList').css('display', 'inline');
          // Esconde o icone de full screen
          $('.ativar-fullScreen').css('display', 'none');
          // Mostra a mensagem de erro
          $('.previsaoList').append('<font color="RED" size="10">Ocorreu um erro, tente novamente!</font>');
        });
      }else if(produto === 'agricultor'){
        var latitude = $('#menu_Agricultor #latitude').val();
        var longitude = $('#menu_Agricultor #longitude').val();
        if(latitude !== '' && longitude !== '') {
          $('.img').css('display', 'inline'); 
          $('.img').attr('src', Loading);
          
          $('.previsaoList').css('display', 'none'); // Esconde a div que mostra o erro e o icone full screen
          $('.previsaoList').find('font').remove(); // Remove o span de erro
          // eslint-disable-next-line        
          var data = $('#menu_Agricultor .data').val();
          // eslint-disable-next-line
          var rodada = $('#menu_Agricultor .rodada').val();

          $.get(`${api_Estatico}/agricultor/${latitude}/${longitude}/${data}/${rodada}`, function(response) {
            if(response.base64.includes('data:text/xml;')){
              $('.img').css('display', 'none');
              $('.previsaoList').css('display', 'inline');
              $('.ativar-fullScreen').css('display', 'none');
              $('.previsaoList').append('<font color="RED" size="10">A imagem não existe, tente com outros parâmetros!</font>');
            }else{
              $('.img').attr('src', response.base64);
              // $('.imgHref').attr('href', response.base64);
              $('.previsaoList').css('display', 'inline');
              $('.ativar-fullScreen').css('display', 'inline');
            }
          }).fail(function(){
            // Esconde a imagem de load
            $('.img').css('display', 'none');
            // Mostra a div que irá mostrar a mensagem de erro
            $('.previsaoList').css('display', 'inline');
            // Esconde o icone de full screen
            $('.ativar-fullScreen').css('display', 'none');
            // Mostra a mensagem de erro
            $('.previsaoList').append('<font color="RED" size="10">Ocorreu um erro, tente novamente!</font>');
          });
        }
      }
      $('.previsaoList').css('display', 'inline');
    });

    $('.img').click(function(){
      const base64ImageData = this.src
      const contentType = 'image/png';

      const byteCharacters = atob(base64ImageData.substr(`data:${contentType};base64,`.length));
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);

          for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, '', '_blank');
    })

    // ========== INICIO MENU LATERAL ==========
    function mobilecheck() {
      var check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  
    function gnMenu( el, options ) {	
      this.el = el;
      this._init();
    }

    gnMenu.prototype = {
      _init : function() {
        this.trigger = this.el.querySelector( 'a.gn-icon-menu' );
        this.menu = this.el.querySelector( 'nav.gn-menu-wrapper' );
        isMenuOpen = false;
        this.eventtype = mobilecheck() ? 'touchstart' : 'click';
        this._initEvents();
  
        var self = this;
        this.bodyClickFn = function() {
          self._closeMenu();
          this.removeEventListener( self.eventtype, self.bodyClickFn );
        };
      },
      _initEvents : function() {
        var self = this;
  
        if( !mobilecheck() ) {
          this.menu.addEventListener( 'mouseover', function(ev) {
            self._openMenu(); 
            document.addEventListener( self.eventtype, self.bodyClickFn ); 
          } );
        }
        this.trigger.addEventListener( this.eventtype, function( ev ) {
          ev.stopPropagation();
          ev.preventDefault();
          if( isMenuOpen ) {
            self._closeMenu();
            document.removeEventListener( self.eventtype, self.bodyClickFn );
          }
          else {
            self._openMenu();
            document.addEventListener( self.eventtype, self.bodyClickFn );
          }
        } );
        this.menu.addEventListener( this.eventtype, function(ev) { ev.stopPropagation(); } );
      },
      _openIconMenu : function() {
        classie.add( this.menu, 'gn-open-part' );
      },
      _closeIconMenu : function() {
        classie.remove( this.menu, 'gn-open-part' );
      },
      _openMenu : function() {
        if( isMenuOpen ) return;
        classie.add( this.trigger, 'gn-selected' );
        isMenuOpen = true;
        classie.add( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      },
      _closeMenu : function() {
        if( !isMenuOpen ) return;
        classie.remove( this.trigger, 'gn-selected' );
        isMenuOpen = false;
        classie.remove( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      }
    }

    new gnMenu( document.getElementById( 'gn-menu' ) );
    // ========== FIM MENU LATERAL ==========
  }
    
  render() {
    return (
      <div className="App">
        <div className="container">
          <ul id="gn-menu" className="gn-menu-main">
            <li className="gn-trigger">
              {/* eslint-disable-next-line */}
              <a className="gn-icon-menu" id="menu">
                <span>Abrir / Fechar</span>
              </a>
              <nav className="gn-menu-wrapper" id="wrapper">
                <div className="gn-scroller">
                  <ul className="gn-menu">
                    <li><span>INMET :: Meteogramas</span></li>
                    <hr />
                    <li><span>Produto: </span><select className="produto"></select></li>
                    <hr />

                    <div id="menu_Estatico">
                      <li><span>Modelo:</span><select className="modelo"></select></li>
                      <li><span>País:</span><select className="pais"></select></li>
                      <li><span>Estado:</span><select className="estado"></select></li>
                      <li><span>Cidade:</span><select className="cidade"></select></li>
                      <li><span>Data:</span><select className="data"></select></li>
                      <li><span>Rodada (UTC):</span><select className="rodada"></select></li>
                      <hr />
                      <li><button className="submit" id="submit_Estatico" style={{ display : 'none' }}>Gerar Meteograma</button></li>
                    </div>

                    <div id="menu_Dinamico">
                      <li>
                        <div style={{ textAlign: 'center', lineHeight : '0'}}>
                          <span style={{ fontSize : '14px', fontWeight : 'bold', color: 'red' }}>Digite sua cidade!</span>
                        </div>
                        <span>Cidade:</span><input type="search" className="search" id="search" placeholder="Buscar Cidade" autoComplete="on" />
                      </li>
                      <li><span>Data:</span><select className="data"></select></li>
                      <li><span>Rodada (UTC):</span><select className="rodada"></select></li>
                      <hr />
                      <li><button className="submit" id="submit_Dinamico" style={{ display : 'none' }}>Gerar Meteograma</button></li>
                    </div>

                    <div id="menu_Agricultor">
                      <li>
                        <div style={{ textAlign: 'center', lineHeight : '0'}}>
                          <span style={{ fontSize : '14px', fontWeight : 'bold', color: 'red' }}>Digite sua Latitude!</span>
                        </div>
                        <span>Latitude:</span><input type="input" className="agricultor_latitude" id="latitude" />
                      </li>
                      <li>
                        <div style={{ textAlign: 'center', lineHeight : '0'}}>
                          <span style={{ fontSize : '14px', fontWeight : 'bold', color: 'red' }}>Digite sua Longitude!</span>
                        </div>
                        <span>Longitude:</span><input type="input" className="agricultor_longitude" id="longitude" />
                      </li>
                      <li><span>Data:</span><select className="data"></select></li>
                      <li><span>Rodada (UTC):</span><select className="rodada"></select></li>
                      <hr />
                      <li><button className="submit" id="submit_Agricultor">Gerar Meteograma</button></li>
                    </div>
                    
                    <div style={{ padding: 15, lineHeight: 'initial'}}>
                      <b>
                        <font size="3" color="red">
                          Para visualizar somente a imagem, favor clicar sobre a mesma.
                          <br /><br />
                          Certifique-se que seu bloqueador de pop-up esteja desabilitado para este sistema.
                        </font>
                      </b>
                    </div>

                  </ul>
                </div>
              </nav>
            </li>
            <li className="inmetName"><a href="https://portal.inmet.gov.br/">Instituto Nacional de Meteorologia</a></li>
          </ul>
          
          <div id="containerFullScreen">
            <div className="imgWrapper">
              {/* <br /> */}
              <b><font className="municipio" size="5" color="#0F4098"></font></b>
  
              <img className="img" id="img" alt="" />
            </div>

            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
            {/* <div className="previsaoList">
              <span className="ativar-fullScreen"><span style={{fontSize: 25}}>Tela Cheia</span></span>
            </div> */}
            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
          </div>
        </div>
      </div>
      );
    }
  }
export default Index;
    